<template>
  <div class="content2 setmargin">
    <div class="sc-kAdXeD jwoEpG" style="padding: 40px 20px 0px 20px!important;">
       <div v-if="propsdata[0]['path'] === '/dashboard/' || propsdata[0]['path'] === '/dashboard/bookmarked-logos'" class="sc-bvTASY jPMoWD">
          <div class="mb-4 sinpaddingmobile" style="display: flex;justify-content: space-between;padding-top: 60px;">
            <h4 v-if="propsdata[0]['path'] === '/dashboard/'" class="f342fdw" style="color: #4a5073;"><i class="fa-solid fa-icons mr-2"></i> My Logos</h4>
            <h4 v-else-if="propsdata[0]['path'] === '/dashboard/bookmarked-logos'" class="f342fdw" style="color: #4a5073;"><i class="fa-solid fa-bookmark mr-2"></i> Bookmarked Logos</h4>
            <a href="/create/" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create New Logo
            </a>
           </div>
           <a href="/create/" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create New Logo
           </a>
         <hr>
       </div>
       <div v-if="propsdata[0]['path'] === '/dashboard/business-cards'" class="sc-bvTASY jPMoWD">
          <div class="mb-4 sinpaddingmobile" style="display: flex;justify-content: space-between;padding-top: 60px;">
            <h4 class="f342fdw" style="color: #4a5073;"><i class="fa-solid fa-signature mr-2"></i> Business Cards</h4>
            <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" data-toggle="modal" data-target="#modal-business-cards" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create Business Card
            </a>
            <router-link v-else to="/dashboard/create-business-card" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create Business Card
            </router-link>
           </div>
           <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" data-toggle="modal" data-target="#modal-business-cards" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create Business Card
            </a>
           <router-link v-else to="/dashboard/create-business-card" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create Business Card
           </router-link>
         <hr>
       </div>
       <div v-if="propsdata[0]['path'] === '/dashboard/email-signatures'" class="sc-bvTASY jPMoWD">
          <div class="mb-4 sinpaddingmobile" style="display: flex;justify-content: space-between;padding-top: 60px;">
            <h4 class="f342fdw" style="color: #4a5073;"><i class="fa-solid fa-signature mr-2"></i> Email Signatures</h4>
            <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" data-toggle="modal" data-target="#modal-email-signatures" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create Email Signature
            </a>
            <router-link v-else to="/dashboard/create-email-signature" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create Email Signature
            </router-link>
           </div>
           <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" data-toggle="modal" data-target="#modal-email-signatures" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create Email Signature
            </a>
           <router-link v-else to="/dashboard/create-email-signature" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create Email Signature
           </router-link>
         <hr>
       </div>
       <div v-if="propsdata[0]['path'] === '/dashboard/link-in-bio'" class="sc-bvTASY jPMoWD">
          <div class="mb-4 sinpaddingmobile" style="display: flex;justify-content: space-between;padding-top: 60px;">
            <h4 class="f342fdw" style="color: #4a5073;"><i class="fa-solid fa-mobile-screen-button mr-2"></i> Link In Bio</h4>
            <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" data-toggle="modal" data-target="#modal-link-in-bio" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create Link In Bio
            </a>
            <router-link v-else to="/dashboard/create-link-in-bio" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color:#fff;background-color: #ed1d62!important;">
               <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
               </svg>
               Create Link In Bio
            </router-link>
           </div>
           <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" data-toggle="modal" data-target="#modal-link-in-bio" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create Link In Bio
            </a>
           <router-link v-else to="/dashboard/create-link-in-bio" class="sc-kkGfuU sc-guztPN cTABXS" style="color:#fff;background-color: #ed1d62!important;">
              <svg class="sc-jhaWeW kclIni" width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg">
                 <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path>
              </svg>
              Create Link In Bio
           </router-link>
         <hr>
       </div>
     </div>
    </div>
</template>

<style>
/* NAV ACTIVE */
.router-link-exact-active{
background: #f3f5f9;
color: #2a354f!important;
}
.router-link-exact-active:hover{
background: #f3f5f9;
color: #2a354f!important;
}
#quesedeslice::-webkit-scrollbar {
    width: 5px;
}
#quesedeslice::-webkit-scrollbar-thumb {
    background: #ccc;
    border: 0 none #fff;
    border-radius: 50px;
}

#quesedeslice::-webkit-scrollbar-track {
    background: #e7e7e7;
    border: 0 none #fff;
    border-radius: 7px;
}
@media (max-width:767px) {
  .dropdown_folders{
    left: unset!important;
  }
}
[v-cloak] { display: none; };
</style>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  props:['propsdata'],
  data(){
    return {
    }
  },
  methods: {
},
mounted(){
},
// do not forget this section
directives: {
ClickOutside
}
};
</script>



// WEBPACK FOOTER //
// src/manage-bar.vue